import styled from "styled-components";

export const StyledHeader = styled.h1`
  font-size: 25px;
`;
